module.exports = new __parcel__URL__("chest_icon_large.41ac485f.png").toString();